import List from '../../../list/list';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as buttonInHomeAction from "../../../../redux/actions/button.action";

const buttonInHomeFields = [
  //list will sort by the first element by default
	"name",
  "link",
  "publishedAt",
];

const ButtonInHomeList = ({member}) => {
	const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const initialParams = {
    fieldTofilter: "name",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
    member
  };

  const { buttons, meta, listLoading, error } = useSelector((state) => ({
    buttons: state.button.buttonList,
    meta: state.button.buttonMetadata,
    listLoading: state.button.listLoading,
    error: state.button.error,
  }));

  useEffect(() => {
    buttonInHomeAction.fetchAll(dispatch, initialParams);
  }, [dispatch, member]);


	return (
		<List
			title='Buttons In Home'
			redirect={`/buttons-in-home/member/${member}/form`}
      columnNames={['NAME', "LINK", "Visibility"]}
			entities={buttons?.data?.map(({ id, attributes: { name, link, visibility } }) => {
        const getVisibilityLabel = (vis) => {
          switch(vis) {
            case 'only_member_portal': return 'Member Portal Only';
            case 'only_retiree_portal': return 'Medicare Portal Only';
            case 'both_portals': return 'Both Portals';
            default: return 'Member Portal Only';
          }
        };
        
        return {
        id,
				columns: [
					{ primary: name },
          { primary: link },
          { primary: getVisibilityLabel(visibility) }
				],
        name,
      };
      })}
      fieldsToSort={buttonInHomeFields}
      fetchAction={(params) => buttonInHomeAction.fetchAll(dispatch, {...params, member})}
      isOverview={false}
      metadata={meta}
      tooltipTextDelete='Delete Button In Home'
      showFilterTab={false}
      member={member}
      deleteAction={(id, params) => buttonInHomeAction.remove(dispatch, id, params)}
      listLoading={listLoading}
      showAlert={showAlert}
      setShowAlert={setShowAlert}
      successAlertMessage={alertMessage}
      customListError={errorMessage}
		/>
	);
};

export default ButtonInHomeList;
